import { AutogenModelEdiOrdersList, AutogenRowEdiOrdersList } from "./autogen/AutogenModelEdiOrdersList";

export class ModelEdiOrdersList extends AutogenModelEdiOrdersList<RowEdiOrdersList> {
    constructor() {
        super(RowEdiOrdersList);
    }
}

export class RowEdiOrdersList extends AutogenRowEdiOrdersList {
}